import { useState } from 'react';
import { FormItem } from '../Form/FormItem';
import { InputElement, InputProps as IInputProps } from '../Input/Input';

export interface IProps extends IInputProps {
  /** Event fired when the toggle password button is clicked */
  onClick?: (e?: React.MouseEvent) => void;
  /** Optional auto-complete. Defaults to true  */
  autoComplete?: boolean;
}

export const PasswordInput = ({
  ariaLabel,
  autoComplete = true,
  autoFocus,
  color,
  disabled,
  hint,
  inputId = 'PasswordInput',
  label,
  name,
  onChange,
  placeholder,
  required,
  spacingBelow,
  tabIndex,
  tooltipDescription,
  tooltipHeading,
  tooltipWidth,
  type,
  validationMessage,
  validationState,
  value,
}: IProps) => {
  const [passwordHidden, setPasswordHidden] = useState<boolean>(true);
  const handleChange = e => {
    if (onChange) {
      onChange(e.target.value);
    }
  };
  const handleClick = e => {
    e.stopPropagation();
    setPasswordHidden(!passwordHidden);
  };

  return (
    <FormItem
      label={label}
      color={color}
      validationMessage={validationMessage}
      validationState={validationState}
      spacingBelow={spacingBelow}
      hint={hint}
      tooltipHeading={tooltipHeading}
      tooltipDescription={tooltipDescription}
      tooltipWidth={tooltipWidth}
      disabled={disabled}
      for={inputId}
      onPasswordToggleClick={handleClick}
      passwordVisible={passwordHidden}
    >
      <InputElement
        type={passwordHidden ? 'password' : 'text'}
        required={required}
        placeholder={placeholder}
        onChange={handleChange}
        value={value}
        name={name}
        tabIndex={tabIndex}
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus={autoFocus}
        aria-label={ariaLabel}
        autoComplete={type === 'email' ? 'email' : 'off'}
        data-testid={inputId}
        disabled={disabled}
        auto-complete={autoComplete}
        data-lpignore={!autoComplete}
        id={inputId}
      />
    </FormItem>
  );
};
